<template>
	<vue-form v-on:submit="saveInvoice" :save-buttons-hidden="isFinalized" :working="detailsSaveWorking" :no-top-button="true">

		<section>

			<div v-if="invoiceSlug == 'new' && hasServices == null" class="invoice-type-buttons">
				<p style="font-size: 14pt;">What kind of invoice would you like to create?</p>
				<button v-on:click="hasServices = true" type="button" class="m-2 btn btn-light">
					Batch Invoice
				</button>
				<button v-on:click="freeformInvoice" type="button" class="m-2 btn btn-light">
					Freeform Invoice
				</button>
			</div>

			<h3 v-if="hasServices !== null">{{typeName}} Details</h3>

			<field v-if="!isSingleService && hasServices && (servicesList.length != 0 || invoiceSlug == 'new')"
				label="Services on Invoice"
				col-class="col-md-4 col-lg-3"
				:params="{type:'select-multi',expandedStyling:true,options:invoiceableServiceOptions}" 
				v-model="servicesList"
				:readonly="isFinalized">
			</field>

			<form-group v-if="isFreeform == 1" label="Customer" col-class="col-sm-3 col-lg-2">

				<div class="d-flex flex-wrap">
					<field
						style="flex-grow: 1; margin-right: 10px; max-width: 100%;"
						:params="{type:'select',options:$store.customerOptions}"
						v-model="localCustomerId"
						v-on:change="customerChange"
						:readonly="isFinalized">
					</field>

					<div>
						<button v-if="!isFinalized && hasModulePermWrite('Contacts')" class="btn btn-light float-right" type="button" v-on:click="newCustomerModalVisible = true">
							<i class="fa fa-plus"></i>
							New Customer
						</button>
					</div>
				</div>
			</form-group>

			<field v-if="!isFinalized"
				:label="'Assign a Manual ' + typeName + ' Number'"
				col-class="col-auto"
				v-model="hasManualInvoiceNumber"
				:params="{type: 'boolean'}"
				:readonly="isFinalized"
				:control-left="true"
				v-on:change="hasManualInvoiceNumberToggled">
			</field>

			<field v-if="hasManualInvoiceNumber"
				:label="'Manual ' + typeName + ' Number'"
				col-class="col-md-6"
				v-model="manualInvoiceNumber"
				:readonly="isFinalized"
				:params="{type: 'text'}"
				v-on:change="emitInput">
			</field>

			<field v-if="isSingleService || (invoiceSlug && invoiceSlug != 'new')"
				class="mb-2"
				:label="workDescriptionLabel"
				col-class="stacked"
				:params="editorParams" 
				v-model="workCompletedDescription"
				v-on:input="debounce('emitInput',false,3000)"
				:readonly="isFinalized">
			</field>

		</section>

		<new-contact-modal
			:visible="newCustomerModalVisible"
			:is-customer="true"
			v-on:contactAdded="customerAdded"
			v-on:closeModal="newCustomerModalVisible = false">
		</new-contact-modal>

	</vue-form>
</template>
<script type="text/javascript">
import VueForm from "@/components/VueForm"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup.vue"
import NewContactModal from "@/components/super_components/NewContactModal.vue"

export default {
	name: "InvoiceDetailsSection",
	components: {
		Field,
		VueForm,
		FormGroup,
		NewContactModal
	},
	props: [
		/**
			Object: {
				description: string, work completed description,
				services: array, array of service ids that belong to this invoice,
				customer_id: int
			}
		*/
		"value",
		"detailsSaveWorking",
		"typeName",
		"isSingleService", //defines whether this is a batch invoice or not
		"addableServices",
		"invoiceSlug",
		"isFinalized"
	],
	data() {
		return {
			workCompletedDescription: "",
			servicesList: [],
			localCustomerId: null,
			isFreeform: false,
			hasServices: null,
			newCustomerModalVisible: false,
			hasManualInvoiceNumber: false,
			manualInvoiceNumber: ""
		}
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.setLocalValues()

				if (this.servicesList.length == 0 && this.$store.customers.length == 0)
					this.fetchCustomers()
			}
		},
		servicesList() {
			this.emitInput()
		},
	},
	computed: {
		editorParams() {

			let vm = this

			let additionalEditorButtons = []

			if (this.typeName == 'Invoice' && "ServiceInvoice" in this.$store.service && this.$store.service.ServiceInvoice) {

				let quote = vm.$store.service.ServiceInvoice.find(inv => inv.is_quote == 1)

				if (quote) {

					additionalEditorButtons = [
						{
							buttonIdentifier: 'insertQuoteDescription',
							text: 'Insert Quote Description',
							action: function(editor) {
								editor.insertContent(quote.work_completed_description)
							}
						},
						{
							buttonIdentifier: 'insertWorkCompletedEntries',
							text: 'Insert Work Completed Entries',
							action: function(editor) {

								let params = {
									filters: [
										['service_id',vm.$store.service.id]
									],
									include: [
										"CustomerAsset"
									]
								}

								vm.getJSON("ServiceWorksheet/get",params).then(response => {
									if (response.success) {
										let compiledWorkCompletedEntries = response.data.map(entry => {
											let entryDate = vm.moment(entry.created_at).format("MMM DD")

											let workCompletedEntry = "<p><strong>"+entryDate+"</strong><br>"
											if ("CustomerAsset" in entry && entry.CustomerAsset)
												workCompletedEntry += "Asset: "+entry.CustomerAsset.description+" (S/N "+entry.CustomerAsset.serial_num+")</p>"

											workCompletedEntry += entry.work_completed_description

											return workCompletedEntry
										})

										editor.insertContent(compiledWorkCompletedEntries.join("<hr>"))
									}
								})
								
							}
						}
					]
				}
			}

			additionalEditorButtons = [
				...additionalEditorButtons,
				{
					buttonIdentifier: 'insertServiceWorkToDo',
					text: 'Insert Work-to-Do',
					action: function(editor) {
						editor.insertContent(vm.$store.service.description)
					}
				}
			]

			return {
				type:'richtext',
				height:'250px',
				additionalEditorButtons
			}
		},
		customerOptions() {
			return this.optionify()
		},
		workDescriptionLabel() {
			if (this.typeName == 'Invoice') {
				if (this.isSingleService || this.value.is_freeform == 1)
					return "Work Completed"
				else
					return "Compiled Work Completed"
			}
			else
				return "Work Requested"
		},
		invoiceableServiceOptions() {
			let vm = this

			let filteredServices = this.addableServices.filter(service => {
				if (vm.servicesList.length > 0) {
					let firstSelectedService = vm.addableServices.find(selected => selected.id == vm.servicesList[0])

					if (service.customer_id == firstSelectedService.customer_id) 
						return true
					else
						return false
				}
				else
					return true
			})

			return this.optionify(filteredServices.map(service => {
				service.label = service.job_num+": "+service.Customer.name+" ("+service.status+")"

				return service
			}),"label")
		}
	},
	methods: {
		customerAdded(response) {
			let vm = this
			this.newCustomerModalVisible = false
			this.fetchCustomers().then(customerResponse => {
				vm.customerChange(response.data.record_id)
			})
		},
		setLocalValues() {
			if (this.value && Object.keys(this.value).length > 0) {
				if ("work_completed_description" in this.value)
					this.workCompletedDescription = this.value.work_completed_description
				if ("services" in this.value) 
					this.servicesList = this.value.services
				if ("is_freeform" in this.value)
					this.isFreeform = this.value.is_freeform
				if ("customer_id" in this.value)
					this.localCustomerId = this.value.customer_id
				if ("manual_invoice_number" in this.value) {
					this.manualInvoiceNumber = this.value.manual_invoice_number

					if (this.manualInvoiceNumber)
						this.hasManualInvoiceNumber = true
				}

				if (this.servicesList > 0)
					this.hasServices = true
			}
		},
		hasManualInvoiceNumberToggled(value) {
			this.manualInvoiceNumber = ""

			this.emitInput()
		},
		emitInput() {
			

			const payload = {
				work_completed_description: this.workCompletedDescription,
				manual_invoice_number: this.manualInvoiceNumber,
				services:this.servicesList,
				customer_id: this.localCustomerId,
				is_freeform: this.isFreeform
			}

			if (this.workCompletedDescription)
				payload.work_completed_description = this.workCompletedDescription

			if (!payload.customer_id && this.servicesList && this.servicesList.length > 0) {
				let service = this.addableServices.find(service => service.id == this.servicesList[0])

				payload.customer_id = service.customer_id
			}

			this.$emit("input",payload)
			this.$emit("change",payload)
		},
		customerChange(value) {
			this.localCustomerId = value
			this.emitInput()
		},
		freeformInvoice() {
			this.isFreeform = true
			this.emitInput()
			//this.saveInvoice()
		},
		saveInvoice() {
			let noServices = false
			if (!this.hasServices)
				noServices = true

			this.emitInput()
			this.$emit("saveInvoice",noServices)
		}
	}
}
</script>

<style type="text/css" scoped>
	section {
		max-width: 1000px;
		margin: auto;
	}

	.invoice-type-buttons {
		text-align: center;
	}

	.invoice-type-buttons button {
		font-size: 16pt;
		padding: 20px;
		background-color: #fff;
	}

	.invoice-type-buttons button:hover {
		background-color: #e0e0e0;
	}
</style>